//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

interface LocaleStrings {
  ecommerceProductDetailsCta: string;
  galleryLinkCta: string;
  galleryLinkUrl: string;
  headerSubtext: string;
  headerText: string;
  hoverText: string;
  itemTrayTitle: string;
  loadMoreCtaText: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  uploaderCtaText: string;
  uploaderTermsAndConditionsLink: string;
}

export const localizationStrings: Record<string, LocaleStrings> = {
  'da-dk': {
    ecommerceProductDetailsCta: 'Køb',
    galleryLinkCta: 'Se galleri',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Køb nu',
    itemTrayTitle: 'Køb dette look',
    loadMoreCtaText: 'Hent mere',
    primaryButtonText: 'Læg i kurv',
    secondaryButtonText: 'Se mere',
    uploaderCtaText: 'Upload medier',
    uploaderTermsAndConditionsLink: '',
  },
  'de-de': {
    ecommerceProductDetailsCta: 'Jetzt',
    galleryLinkCta: 'Galerie ansehen',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Jetzt einkaufen',
    itemTrayTitle: 'Diesen Look einkaufen',
    loadMoreCtaText: 'Mehr laden',
    primaryButtonText: 'In den Warenkorb',
    secondaryButtonText: 'Mehr anzeigen',
    uploaderCtaText: 'Mehr Inhalt hochladen',
    uploaderTermsAndConditionsLink: '',
  },
  'en-ca': {
    ecommerceProductDetailsCta: 'Shop',
    galleryLinkCta: 'View Gallery',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Shop Now',
    itemTrayTitle: 'Shop this look',
    loadMoreCtaText: 'Load More',
    primaryButtonText: 'Add to Cart',
    secondaryButtonText: 'View More',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
  },
  'en-eu': {
    ecommerceProductDetailsCta: 'Shop',
    galleryLinkCta: 'View Gallery',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Shop Now',
    itemTrayTitle: 'Shop this look',
    loadMoreCtaText: 'Load More',
    primaryButtonText: 'Add to Cart',
    secondaryButtonText: 'View More',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
  },
  'en-gb': {
    ecommerceProductDetailsCta: 'Shop',
    galleryLinkCta: 'View Gallery',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Shop Now',
    itemTrayTitle: 'Shop this look',
    loadMoreCtaText: 'Load More',
    primaryButtonText: 'Add to Cart',
    secondaryButtonText: 'View More',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
  },
  'en-us': {
    ecommerceProductDetailsCta: 'Shop',
    galleryLinkCta: 'View Gallery',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Shop Now',
    itemTrayTitle: 'Shop this look',
    loadMoreCtaText: 'Load More',
    primaryButtonText: 'Add to Cart',
    secondaryButtonText: 'View More',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
  },
  'es-es': {
    ecommerceProductDetailsCta: 'Compra',
    galleryLinkCta: 'Ver galería',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Compra ahora',
    itemTrayTitle: 'Compra este modelo',
    loadMoreCtaText: 'Cargar más',
    primaryButtonText: 'Añadir al carrito',
    secondaryButtonText: 'Ver más',
    uploaderCtaText: 'Descargar contenido',
    uploaderTermsAndConditionsLink: '',
  },
  'es-mx': {
    ecommerceProductDetailsCta: 'Comprar',
    galleryLinkCta: 'Ver galería',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Comprar ahora',
    itemTrayTitle: 'Comprar este estilo',
    loadMoreCtaText: 'Cargar más',
    primaryButtonText: 'Añadir al carrito',
    secondaryButtonText: 'Ver más',
    uploaderCtaText: 'Cargar elementos multimedia',
    uploaderTermsAndConditionsLink: '',
  },
  'es-us': {
    ecommerceProductDetailsCta: 'Comprar',
    galleryLinkCta: 'Ver Galería',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Comprar ahora',
    itemTrayTitle: 'Comprar este estilo',
    loadMoreCtaText: 'Cargar más',
    primaryButtonText: 'Añadir al carrito',
    secondaryButtonText: 'Ver más',
    uploaderCtaText: 'Cargar multimedia',
    uploaderTermsAndConditionsLink: '',
  },
  'et-ee': {
    ecommerceProductDetailsCta: 'Osta kohe',
    galleryLinkCta: 'Vaata galeriid',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Osta kohe',
    itemTrayTitle: 'Osta see välimus',
    loadMoreCtaText: 'Laadi rohkem',
    primaryButtonText: 'Lisa ostukorvi',
    secondaryButtonText: 'Vaata rohkem üksikasju',
    uploaderCtaText: 'Laadi üles meedia',
    uploaderTermsAndConditionsLink: '',
  },
  'fr-ca': {
    ecommerceProductDetailsCta: 'Acheter',
    galleryLinkCta: 'Afficher la bibliothèque',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Acheter maintenant',
    itemTrayTitle: 'Acheter cette tenue',
    loadMoreCtaText: 'Plus',
    primaryButtonText: 'Ajouter au panier',
    secondaryButtonText: 'Voir plus',
    uploaderCtaText: 'Téléverser un élément multimédia',
    uploaderTermsAndConditionsLink: '',
  },
  'fr-fr': {
    ecommerceProductDetailsCta: 'Acheter',
    galleryLinkCta: 'Afficher la galerie',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Acheter maintenant',
    itemTrayTitle: 'Acheter ce style',
    loadMoreCtaText: 'Charger plus',
    primaryButtonText: 'Ajouter au panier',
    secondaryButtonText: 'Voir plus',
    uploaderCtaText: 'Télécharger le média',
    uploaderTermsAndConditionsLink: '',
  },
  'it-it': {
    ecommerceProductDetailsCta: 'Compra',
    galleryLinkCta: 'Guarda la galleria',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Compra ora',
    itemTrayTitle: 'Acquista questo look',
    loadMoreCtaText: 'Carica di più',
    primaryButtonText: 'Aggiungi al carrello',
    secondaryButtonText: 'Vedi altro',
    uploaderCtaText: 'Aggiungi Altre Foto',
    uploaderTermsAndConditionsLink: '',
  },
  'ja-jp': {
    ecommerceProductDetailsCta: '今すぐ購入',
    galleryLinkCta: 'ギャラリーを見る',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: '今すぐ購入',
    itemTrayTitle: 'このルックを購入',
    loadMoreCtaText: 'もっと読み込む',
    primaryButtonText: 'カートに追加',
    secondaryButtonText: '詳細を見る',
    uploaderCtaText: 'メディアをアップロードする',
    uploaderTermsAndConditionsLink: '',
  },
  'ko-kr': {
    ecommerceProductDetailsCta: '지금 쇼핑하기',
    galleryLinkCta: '갤러리 보기',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: '지금 쇼핑하기',
    itemTrayTitle: '이 룩 쇼핑하기',
    loadMoreCtaText: '더 보기',
    primaryButtonText: '장바구니에 추가',
    secondaryButtonText: '더 많은 세부 정보 보기',
    uploaderCtaText: '미디어 업로드',
    uploaderTermsAndConditionsLink: '',
  },
  'lt-lt': {
    ecommerceProductDetailsCta: 'Apsipirkti dabar',
    galleryLinkCta: 'Peržiūrėti galeriją',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Apsipirkti dabar',
    itemTrayTitle: 'Apsipirkti šiuo stiliumi',
    loadMoreCtaText: 'Įkelti daugiau',
    primaryButtonText: 'Pridėti į krepšelį',
    secondaryButtonText: 'Peržiūrėti daugiau informacijos',
    uploaderCtaText: 'Įkelti mediją',
    uploaderTermsAndConditionsLink: '',
  },
  'lv-lv': {
    ecommerceProductDetailsCta: 'Iepirkties tagad',
    galleryLinkCta: 'Skatīt galeriju',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Iepirkties tagad',
    itemTrayTitle: 'Iegādāties šo izskatu',
    loadMoreCtaText: 'Ielādēt vairāk',
    primaryButtonText: 'Pievienot grozam',
    secondaryButtonText: 'Skatīt vairāk informācijas',
    uploaderCtaText: 'Augšupielādēt multividi',
    uploaderTermsAndConditionsLink: '',
  },
  'nl-nl': {
    ecommerceProductDetailsCta: 'Shop',
    galleryLinkCta: 'Bekijk galerij',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Shop nu',
    itemTrayTitle: 'Shop deze look',
    loadMoreCtaText: 'Laad meer',
    primaryButtonText: 'Toevoegen aan winkelwagen',
    secondaryButtonText: 'Bekijk meer',
    uploaderCtaText: 'Upload Media',
    uploaderTermsAndConditionsLink: '',
  },
  'pl-pl': {
    ecommerceProductDetailsCta: 'Kupuj',
    galleryLinkCta: 'Zobacz galerię',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Kupuj teraz',
    itemTrayTitle: 'kupuj ten look',
    loadMoreCtaText: 'Załaduj więcej',
    primaryButtonText: 'Dodaj do koszyka',
    secondaryButtonText: 'Zobacz więcej',
    uploaderCtaText: 'Zaladuj Media',
    uploaderTermsAndConditionsLink: '',
  },
  'pt-br': {
    ecommerceProductDetailsCta: 'Comprar',
    galleryLinkCta: 'Exibir galeria',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Comprar agora',
    itemTrayTitle: 'Pesquisar baseado neste modelo',
    loadMoreCtaText: 'Carregar mais',
    primaryButtonText: 'Adicionar ao carrinho',
    secondaryButtonText: 'Ver mais',
    uploaderCtaText: 'Enviar mídia',
    uploaderTermsAndConditionsLink: '',
  },
  'ru-ru': {
    ecommerceProductDetailsCta: 'Купить',
    galleryLinkCta: 'Открыть галерею',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Купить',
    itemTrayTitle: 'Купить этот образ',
    loadMoreCtaText: 'Загрузить еще',
    primaryButtonText: 'Добавить в корзину',
    secondaryButtonText: 'Показать ещё',
    uploaderCtaText: 'Загрузить медиафайл',
    uploaderTermsAndConditionsLink: '',
  },
  'sv-se': {
    ecommerceProductDetailsCta: 'Shoppa',
    galleryLinkCta: 'Visa galleri',
    galleryLinkUrl: '',
    headerSubtext: '',
    headerText: '',
    hoverText: 'Shoppa nu',
    itemTrayTitle: 'Shoppa den här looken',
    loadMoreCtaText: 'Läs in mer',
    primaryButtonText: 'Lägg i varukorg',
    secondaryButtonText: 'Visa mer',
    uploaderCtaText: 'Ladda upp media',
    uploaderTermsAndConditionsLink: '',
  },
};
